export interface LabMapping {
  abbreviation: string;
  fullName: string;
}

export const labMappings: LabMapping[] = [
  { abbreviation: 'FERA', fullName: 'Fera Science Limited' },
  { abbreviation: 'Meise', fullName: 'Plantentuin Meise' },
  { abbreviation: 'Agroisolab', fullName: 'Agroisolab GmbH' },
  { abbreviation: 'test lab', fullName: 'TEST LAB LEGAL NAME' },
  // Add more lab mappings as needed
];

/**
 * Converts a lab abbreviation to its full legal name
 * @param labAbbreviation - The lab abbreviation to convert
 * @returns The full legal name if found, otherwise returns the original abbreviation
 */
export const getLabFullName = (labAbbreviation: string): string => {
  if (!labAbbreviation) return '';
  
  const mapping = labMappings.find(
    lab => lab.abbreviation.toUpperCase() === labAbbreviation.toUpperCase()
  );
  
  return mapping ? mapping.fullName : labAbbreviation;
};
